import Button from '@ingka/button';
import board from '@ingka/ssr-icon/paths/board';
import Tooltip from '@ingka/tooltip';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  selectCurrentLanguageCode,
  selectCurrentRetailUnit,
} from '../../../store/slices/intl';
export const DashboardLink = () => {
  const retailUnit = useSelector(selectCurrentRetailUnit);
  const languageCode = useSelector(selectCurrentLanguageCode);
  const navigate = useNavigate();

  return (
    <Tooltip
      describedById="shop-dashboard-tooltip"
      interactiveCustomTrigger
      position="bottom"
      tooltipText="Shop Dashboard"
    >
      <Button
        id="shop-dashboard-button"
        aria-label="Go to shop dashboard"
        size="small"
        name="Go to shop dashboard"
        type="tertiary"
        iconOnly
        role="button"
        ssrIcon={board}
        onClick={() => {
          const to = `${retailUnit}/${languageCode}/shop-dashboard`;
          navigate(to);
        }}
      ></Button>
    </Tooltip>
  );
};

export default DashboardLink;
